import ReactDOM from "react-dom";
import { BrowserRouter } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";

// npm i react-router-dom react-redux react-dom react-helmet-async
//
import { Provider } from "react-redux";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
// import AppCss from "./App";
import reportWebVitals from "./reportWebVitals";
import store from "./appRedux/store";
import "./index.css";
// import "bootstrap/dist/css/bootstrap.css";
// import { SocketProvider } from "./appRedux/services/socketContext";
// ----------------------------------------------------------------------
// npm i  @emotion/react@^11.4.0 @emotion/styled@^11.3.0 @iconify/icons-ant-design@^1.1.0 @iconify/icons-eva@^1.1.0 @iconify/icons-ic@^1.1.6 @iconify/react@^1.1.4
//npm i @material-ui/core@^5.0.0-alpha.38 @material-ui/lab@^5.0.0-alpha.38 @material-ui/styles@^5.0.0-alpha.36 @material-ui/utils@^5.0.0-alpha.36

ReactDOM.render(
  <HelmetProvider>
    <BrowserRouter>
      <Provider store={store}>
        {/* <SocketProvider> */}
        <App />
        {/* </SocketProvider> */}
      </Provider>
    </BrowserRouter>
  </HelmetProvider>,
  document.getElementById("root")
);

// If you want to enable client cache, register instead.
serviceWorker.unregister();

reportWebVitals();
